export const CLOSE_BOTTOM_POPUPS_EVENT = 'closeBottomPopups';

export const closeBottomPopups = () => {
	if (typeof window === 'undefined') return;
	window.dispatchEvent(new CustomEvent(CLOSE_BOTTOM_POPUPS_EVENT));
};
